import { render, staticRenderFns } from "./Designation.vue?vue&type=template&id=e58e94c6"
import script from "./Designation.vue?vue&type=script&lang=js"
export * from "./Designation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports